import { createFileRoute } from "@tanstack/react-router";
import OwnerLayout from "@/components/layout/OwnerLayout";

/**
 * Pathless layout route for the owner area.
 * OwnerLayout redirects to /auth when signed out and to /dashboard when the
 * user is not an owner — same gating as the pre-migration layout route.
 */
export const Route = createFileRoute("/_owner")({
  component: OwnerLayout,
});
